

export class FuelTypeOutputWithoutStatus implements IFuelTypeOutputWithoutStatus {
    /** The auto-generated id of the fuel type  master */
    fuel_type_id!: number;
    /** The fuel type name with 255 character limit */
    fuel_type_name!: string;
    /** Manage status of fuel type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IFuelTypeOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuel_type_id = _data["fuel_type_id"];
            this.fuel_type_name = _data["fuel_type_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FuelTypeOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FuelTypeOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuel_type_id"] = this.fuel_type_id;
        data["fuel_type_name"] = this.fuel_type_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IFuelTypeOutputWithoutStatus {
    /** The auto-generated id of the fuel type  master */
    fuel_type_id: number;
    /** The fuel type name with 255 character limit */
    fuel_type_name: string;
    /** Manage status of fuel type. 0 For De-active, 1 For Active */
    status: number;
}

